import type { UnsleepingId } from '@somnhold/content';
import { ansel } from './ansel.ts';
import { bruni } from './bruni.ts';
import { corvin } from './corvin.ts';
import { edda } from './edda.ts';
import { kaela } from './kaela.ts';
import type { Kit } from './kit.ts';
import { lucan } from './lucan.ts';
import { ragna } from './ragna.ts';
import { vela } from './vela.ts';

/** Every Unsleeping's kit, by id. */
export const KITS: Record<UnsleepingId, Kit> = {
  corvin,
  vela,
  ansel,
  lucan,
  bruni,
  ragna,
  edda,
  kaela,
};
